// src/components/Sidebar.jsx
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.scss';

const menu = [
    { to: '/', label: 'Главная', icon: '🏠', end: true },
    { to: '/playlists', label: 'Плейлисты', icon: '🎵' },

    // Аудио
    { to: '/audio-files', label: 'Аудио файлы', icon: '🎧' },
    { to: '/audio-playlists', label: 'Аудио плейлисты', icon: '📻' },
    { to: '/audio-devices', label: 'Аудио по устройствам', icon: '🎚️' },

    // Видео / медиа
    { to: '/files', label: 'Файлы', icon: '📁' },

    // Новое: рекламные кампании (ролики category="ad")
    { to: '/ad-campaigns', label: 'Рекламные кампании', icon: '📺' },

    { to: '/analytics', label: 'Аналитика', icon: '📊' },
    { to: '/companies', label: 'Компании', icon: '🏢' },
    { to: '/settings', label: 'Настройки', icon: '⚙️' },
];

export default function Sidebar() {
    // opened — мобильное открытие (бургер)
    const [opened, setOpened] = useState(false);
    // collapsed — десктопное сворачивание меню (только иконки)
    const [collapsed, setCollapsed] = useState(false);

    const toggleCollapsed = () => {
        setCollapsed(prev => !prev);
    };

    const closeMobile = () => {
        setOpened(false);
    };

    const asideClassName = [
        'sidebar',
        opened ? 'open' : '',
        collapsed ? 'collapsed' : '',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <>
            <div
                className={`sidebar-backdrop${opened ? ' visible' : ''}`}
                onClick={closeMobile}
            />
            <aside className={asideClassName}>
                <div className="sidebar-header">
                    <span className="sidebar-title">Admin</span>

                    {/* кнопка сворачивания меню (десктоп) */}
                    <button
                        type="button"
                        className="sidebar-toggle"
                        onClick={toggleCollapsed}
                    >
                        {collapsed ? '»' : '«'}
                    </button>

                    {/* крестик для закрытия на мобильных */}
                    <button
                        className="sidebar-close"
                        type="button"
                        onClick={closeMobile}
                    >
                        &times;
                    </button>
                </div>

                <nav className="sidebar-nav">
                    {menu.map(item => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            className={({ isActive }) =>
                                isActive ? 'active' : ''
                            }
                            onClick={closeMobile}
                            end={!!item.end}
                        >
                            <span className="sidebar-icon">{item.icon}</span>
                            <span className="sidebar-label">
                                {item.label}
                            </span>
                        </NavLink>
                    ))}
                </nav>
            </aside>

            <button
                className="sidebar-burger"
                type="button"
                onClick={() => setOpened(true)}
            >
                <span />
                <span />
                <span />
            </button>
        </>
    );
}
